/* v3 - global nav with cross-tab navigation */
!(function () {
  "use strict";
  if (customElements.get("tabbed-showcase")) return;

  class TabbedShowcase extends HTMLElement {
    constructor() {
      super();
      this.tabs = [];
      this.mainPanels = [];
      this.contentPanels = [];
      this.sliderGroups = [];
      this.flktyInstances = new Map();
      this.pendingInits = new Set();
      this.readySliders = new Set(); // Track sliders that have fired ready event
      this.pendingNavAction = null; // Queue nav action when Flickity not ready
      this.onResize = this.onResize.bind(this);
      this._activateTabIndex = 1;
      this._activateGoToLast = false;
    }

    connectedCallback() {
      console.log('[TabbedShowcase] connectedCallback - component mounting');
      this.tabs = Array.from(this.querySelectorAll("[data-tab-button]"));
      this.mainPanels = Array.from(this.querySelectorAll("[data-main-image-panel]"));
      this.contentPanels = Array.from(this.querySelectorAll("[data-content-panel]"));
      this.sliderGroups = Array.from(this.querySelectorAll("[data-slider-group]"));
      this.prevBtn = this.querySelector("[data-nav-prev]");
      this.nextBtn = this.querySelector("[data-nav-next]");
      this.sectionElement = this;

      console.log('[TabbedShowcase] Found:', this.tabs.length, 'tabs,', this.sliderGroups.length, 'slider groups,', this.contentPanels.length, 'content panels');

      this.bindEvents();
      this.bindGlobalNav();

      // Apply initial colors from first tab
      if (this.tabs.length > 0) {
        const firstTab = this.tabs[0];
        const firstTabBgColor = firstTab.dataset.tabBgColor;
        const firstTabHeadingColor = firstTab.dataset.tabHeadingColor;

        console.log('[TabbedShowcase] Initial tab colors - heading:', firstTabHeadingColor, 'bg:', firstTabBgColor);

        if (firstTabBgColor && firstTabBgColor !== '' && firstTabBgColor !== 'rgba(0,0,0,0)') {
          this.applyBackgroundColor(firstTabBgColor);
        }

        // Apply heading color to all tab buttons, border only on active (first) tab
        if (firstTabHeadingColor && firstTabHeadingColor !== '' && firstTabHeadingColor !== 'rgba(0,0,0,0)') {
          this.tabs.forEach((tab, index) => {
            tab.style.color = firstTabHeadingColor;
            // Only first tab (active) gets border color
            tab.style.borderColor = index === 0 ? firstTabHeadingColor : 'transparent';
          });
        }
      }

      // Initialize slider immediately for faster first load
      requestAnimationFrame(() => {
        console.log('[TabbedShowcase] RAF - calling initActiveSlider');
        this.initActiveSlider();
      });

      document.addEventListener("theme:resize:width", this.onResize);
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.onResize);
      this.destroySliders();
    }

    bindEvents() {
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const index = Number(tab.dataset.tabIndex || "1");
          this.activateTab(index, false);
        });

        tab.addEventListener("keydown", (event) => {
          if ("ArrowRight" === event.key || "ArrowDown" === event.key) {
            event.preventDefault();
            this.focusAdjacentTab(tab, 1);
          } else if ("ArrowLeft" === event.key || "ArrowUp" === event.key) {
            event.preventDefault();
            this.focusAdjacentTab(tab, -1);
          }
        });
      });
    }

    focusAdjacentTab(currentTab, direction) {
      const index = this.tabs.indexOf(currentTab);
      if (index === -1) return;

      let nextIndex = index + direction;
      if (nextIndex < 0) nextIndex = this.tabs.length - 1;
      if (nextIndex >= this.tabs.length) nextIndex = 0;

      const nextTab = this.tabs[nextIndex];
      if (!nextTab) return;

      nextTab.focus();
      this.activateTab(Number(nextTab.dataset.tabIndex || "1"), false);
    }

    bindGlobalNav() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('[TabbedShowcase] ========== PREV CLICKED ==========');
          const { flkty, groupIndex, group, slider } = this.getActiveFlickity();

          console.log('[TabbedShowcase] flkty:', !!flkty);
          console.log('[TabbedShowcase] groupIndex:', groupIndex);
          console.log('[TabbedShowcase] group:', !!group);
          console.log('[TabbedShowcase] slider:', !!slider);
          console.log('[TabbedShowcase] flkty?.slides:', flkty?.slides?.length);
          console.log('[TabbedShowcase] flkty?.selectedIndex:', flkty?.selectedIndex);
          console.log('[TabbedShowcase] flkty?.cells:', flkty?.cells?.length);

          // Check if Flickity is truly ready (has slides and valid selectedIndex)
          const isReady = flkty && flkty.slides && flkty.slides.length > 0 && typeof flkty.selectedIndex === 'number';
          console.log('[TabbedShowcase] isReady:', isReady);

          if (!isReady) {
            console.log('[TabbedShowcase] Flickity not ready, queuing prev action...');
            this.pendingNavAction = 'prev';
            if (group && !this.flktyInstances.has(slider)) {
              console.log('[TabbedShowcase] Initializing slider...');
              this.initSliderForGroup(group);
            } else if (flkty) {
              // Slider exists but not fully ready, try executing after a short delay
              console.log('[TabbedShowcase] Slider exists, waiting for ready...');
              setTimeout(() => {
                this.executePendingNavAction(flkty, groupIndex);
              }, 50);
            }
            return;
          }

          this.executePrevAction(flkty, groupIndex);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log('[TabbedShowcase] ========== NEXT CLICKED ==========');
          const { flkty, groupIndex, group, slider } = this.getActiveFlickity();

          console.log('[TabbedShowcase] flkty:', !!flkty);
          console.log('[TabbedShowcase] groupIndex:', groupIndex);
          console.log('[TabbedShowcase] group:', !!group);
          console.log('[TabbedShowcase] slider:', !!slider);
          console.log('[TabbedShowcase] flkty?.slides:', flkty?.slides?.length);
          console.log('[TabbedShowcase] flkty?.selectedIndex:', flkty?.selectedIndex);
          console.log('[TabbedShowcase] flkty?.cells:', flkty?.cells?.length);

          // Check if Flickity is truly ready (has slides and valid selectedIndex)
          const isReady = flkty && flkty.slides && flkty.slides.length > 0 && typeof flkty.selectedIndex === 'number';
          console.log('[TabbedShowcase] isReady:', isReady);

          if (!isReady) {
            console.log('[TabbedShowcase] Flickity not ready, queuing next action...');
            this.pendingNavAction = 'next';
            if (group && !this.flktyInstances.has(slider)) {
              console.log('[TabbedShowcase] Initializing slider...');
              this.initSliderForGroup(group);
            } else if (flkty) {
              // Slider exists but not fully ready, try executing after a short delay
              console.log('[TabbedShowcase] Slider exists, waiting for ready...');
              setTimeout(() => {
                this.executePendingNavAction(flkty, groupIndex);
              }, 50);
            }
            return;
          }

          this.executeNextAction(flkty, groupIndex);
        });
      }

      this.updateNavVisibility();
    }

    executePrevAction(flkty, groupIndex) {
      console.log('[TabbedShowcase] executePrevAction - selectedIndex:', flkty.selectedIndex, 'totalSlides:', flkty.slides.length);
      if (flkty.selectedIndex > 0) {
        flkty.previous();
      } else if (groupIndex > 1) {
        // Use queueMicrotask for immediate execution
        queueMicrotask(() => {
          this.activateTab(groupIndex - 1, true);
        });
      }
    }

    executeNextAction(flkty, groupIndex) {
      console.log('[TabbedShowcase] executeNextAction - selectedIndex:', flkty.selectedIndex, 'totalSlides:', flkty.slides.length, 'groupIndex:', groupIndex, 'totalTabs:', this.tabs.length);
      if (flkty.selectedIndex < flkty.slides.length - 1) {
        console.log('[TabbedShowcase] >>> Moving to next slide');
        flkty.next();
      } else if (groupIndex < this.tabs.length) {
        console.log('[TabbedShowcase] >>> At last slide, switching to tab:', groupIndex + 1);
        // Use queueMicrotask for immediate execution
        queueMicrotask(() => {
          this.activateTab(groupIndex + 1, false);
        });
      } else {
        console.log('[TabbedShowcase] >>> At last slide of last tab, nowhere to go');
      }
    }

    executePendingNavAction(flktyParam, groupIndexParam) {
      if (!this.pendingNavAction) return;

      const action = this.pendingNavAction;
      this.pendingNavAction = null;

      // Get fresh slider data in case tab changed
      const { flkty, groupIndex } = this.getActiveFlickity();
      const actualFlkty = flkty || flktyParam;
      const actualGroupIndex = flkty ? groupIndex : groupIndexParam;

      console.log('[TabbedShowcase] Executing pending action:', action, 'flkty:', !!actualFlkty, 'selectedIndex:', actualFlkty?.selectedIndex, 'slides:', actualFlkty?.slides?.length);

      if (!actualFlkty || !actualFlkty.slides || actualFlkty.slides.length === 0) {
        console.log('[TabbedShowcase] Cannot execute pending action - no valid flkty');
        return;
      }

      if (action === 'prev') {
        this.executePrevAction(actualFlkty, actualGroupIndex);
      } else if (action === 'next') {
        this.executeNextAction(actualFlkty, actualGroupIndex);
      }
    }

    getActiveFlickity() {
      for (const group of this.sliderGroups) {
        if (!group.classList.contains("is-active")) continue;
        const slider = group.querySelector("[data-tabbed-showcase-slider]");
        const flkty = slider ? this.flktyInstances.get(slider) : null;
        const groupIndex = Number(group.dataset.tabPanel || "0");
        return { flkty, groupIndex, group, slider };
      }
      return { flkty: null, groupIndex: 0, group: null, slider: null };
    }

    updateNavVisibility() {
      if (!this.prevBtn || !this.nextBtn) return;

      const { flkty, groupIndex } = this.getActiveFlickity();
      const totalTabs = this.tabs.length;

      if (!flkty || !flkty.slides || flkty.slides.length === 0) {
        this.prevBtn.hidden = groupIndex <= 1;
        this.nextBtn.hidden = groupIndex >= totalTabs;
        return;
      }

      const atFirst = flkty.selectedIndex <= 0;
      const atLast = flkty.selectedIndex >= flkty.slides.length - 1;

      this.prevBtn.hidden = atFirst && groupIndex <= 1;
      this.nextBtn.hidden = atLast && groupIndex >= totalTabs;
    }

    initActiveSlider() {
      if (!window.theme || !window.theme.Flickity) return;

      this.sliderGroups.forEach((group) => {
        if (group.classList.contains("is-active")) {
          this.initSliderForGroup(group);
        }
      });
    }

    initSliderForGroup(group) {
      console.log('[TabbedShowcase] initSliderForGroup called', group?.dataset?.tabPanel);
      if (!group || !window.theme || !window.theme.Flickity) {
        console.log('[TabbedShowcase] Missing requirements - group:', !!group, 'theme:', !!window.theme, 'Flickity:', !!window.theme?.Flickity);
        return;
      }

      const slider = group.querySelector("[data-tabbed-showcase-slider]");
      if (!slider) {
        console.log('[TabbedShowcase] No slider element found');
        return;
      }
      if (this.flktyInstances.has(slider) || this.pendingInits.has(slider)) {
        console.log('[TabbedShowcase] Already initialized or pending');
        return;
      }

      this.pendingInits.add(slider);
      console.log('[TabbedShowcase] Starting Flickity init for panel', group.dataset.tabPanel);

      requestAnimationFrame(() => {
        try {
          if (!group.classList.contains("is-active")) {
            this.pendingInits.delete(slider);
            console.log('[TabbedShowcase] Group no longer active, aborting init');
            return;
          }
          if (this.flktyInstances.has(slider)) {
            this.pendingInits.delete(slider);
            console.log('[TabbedShowcase] Already has instance, aborting');
            return;
          }

          const flkty = new window.theme.Flickity(slider, {
            cellAlign: "left",
            contain: true,
            draggable: true,
            pageDots: true,
            prevNextButtons: false,
            wrapAround: false,
            percentPosition: true,
            imagesLoaded: true,
          });

          this.flktyInstances.set(slider, flkty);
          this.pendingInits.delete(slider);
          this.readySliders.add(slider);
          console.log('[TabbedShowcase] Flickity instance created and stored');

          // Set up event handlers after flkty is assigned
          flkty.on('ready', () => {
            console.log('[TabbedShowcase] Flickity READY - selectedIndex:', flkty.selectedIndex, 'slides:', flkty.slides?.length);
            this.updateSlidesA11y(flkty);
            this.applyGoToLastIfNeeded(flkty, group);
            this.updateNavVisibility();
            // Execute any pending navigation action
            const groupIndex = Number(group.dataset.tabPanel || "0");
            this.executePendingNavAction(flkty, groupIndex);
          });

          flkty.on('change', () => {
            console.log('[TabbedShowcase] Flickity CHANGE - selectedIndex:', flkty.selectedIndex);
            this.updateSlidesA11y(flkty);
            this.updateNavVisibility();
          });

          if (window.theme.flickitySmoothScrolling) {
            window.theme.flickitySmoothScrolling(slider);
          }

          requestAnimationFrame(() => {
            this.applyGoToLastIfNeeded(flkty, group);
            this.updateNavVisibility();
            // Execute pending action after a frame
            const groupIndex = Number(group.dataset.tabPanel || "0");
            this.executePendingNavAction(flkty, groupIndex);
          });
        } catch (e) {
          this.pendingInits.delete(slider);
          if (console && console.warn) {
            console.warn("Tabbed showcase: Flickity init failed", e);
          }
        }
      });
    }

    applyGoToLastIfNeeded(flkty, group) {
      if (!flkty || !flkty.slides || !group) return;
      const panel = Number(group.dataset.tabPanel || "0");
      if (panel !== this._activateTabIndex || !this._activateGoToLast) return;
      const last = Math.max(0, flkty.slides.length - 1);
      flkty.select(last, false, true);
      this._activateGoToLast = false;
    }

    destroySliders() {
      this.flktyInstances.forEach((instance) => {
        if (instance && instance.destroy) instance.destroy();
      });
      this.flktyInstances.clear();
      this.pendingInits.clear();
      this.readySliders.clear();
    }

    updateSlidesA11y(flkty) {
      if (!flkty || !flkty.slides) return;
      const sel = flkty.selectedIndex;
      flkty.slides.forEach((slide, i) => {
        slide.cells.forEach((cell) => {
          cell.element.querySelectorAll("a, button").forEach((el) => {
            el.setAttribute("tabindex", i === sel ? "0" : "-1");
          });
        });
      });
    }

    onResize() {
      this.flktyInstances.forEach((flkty) => {
        if (flkty) flkty.resize();
      });
      this.updateNavVisibility();
    }

    applyBackgroundColor(color) {
      console.log('[TabbedShowcase] Applying background color:', color);
      this.style.setProperty('--tab-bg-color', color);
      this.style.backgroundColor = color;

      // Also apply to inner elements that have background set
      const innerElements = this.querySelectorAll('.tabbed-showcase__inner, .tabbed-showcase__main, .tabbed-showcase__image-column, .tabbed-showcase__content-column, .tabbed-showcase__slider-outer');
      innerElements.forEach(el => {
        el.style.backgroundColor = color;
      });
    }

    clearBackgroundColor() {
      console.log('[TabbedShowcase] Clearing background color');
      this.style.removeProperty('--tab-bg-color');
      this.style.backgroundColor = '';

      const innerElements = this.querySelectorAll('.tabbed-showcase__inner, .tabbed-showcase__main, .tabbed-showcase__image-column, .tabbed-showcase__content-column, .tabbed-showcase__slider-outer');
      innerElements.forEach(el => {
        el.style.backgroundColor = '';
      });
    }

    activateTab(index, goToLast) {
      console.log('[TabbedShowcase] activateTab:', index, 'goToLast:', goToLast);
      if (typeof goToLast === "undefined") goToLast = false;
      this._activateTabIndex = index;
      this._activateGoToLast = goToLast;

      // Find the active tab first to get its colors
      let activeTabHeadingColor = null;
      let activeTabBgColor = null;

      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.tabIndex || "0") === index;
        if (isActive) {
          activeTabHeadingColor = tab.dataset.tabHeadingColor;
          activeTabBgColor = tab.dataset.tabBgColor;
        }
      });

      console.log('[TabbedShowcase] Active tab colors - heading:', activeTabHeadingColor, 'bg:', activeTabBgColor);

      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.tabIndex || "0") === index;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
        tab.setAttribute("tabindex", isActive ? "0" : "-1");

        // Apply heading color to tab button text, and border ONLY for active tab
        if (activeTabHeadingColor && activeTabHeadingColor !== '' && activeTabHeadingColor !== 'rgba(0,0,0,0)') {
          tab.style.color = activeTabHeadingColor;
          // Only active tab gets the border color, others transparent
          tab.style.borderColor = isActive ? activeTabHeadingColor : 'transparent';
        } else {
          // No custom color - clear inline styles so CSS defaults apply
          tab.style.color = '';
          // For inactive tabs, set transparent. For active, let CSS handle it
          tab.style.borderColor = isActive ? '' : 'transparent';
        }

        // Apply background color from active tab
        if (isActive) {
          if (activeTabBgColor && activeTabBgColor !== '' && activeTabBgColor !== 'rgba(0,0,0,0)') {
            this.applyBackgroundColor(activeTabBgColor);
          } else {
            this.clearBackgroundColor();
          }
        }
      });

      this.mainPanels.forEach((panel) => {
        const isActive = Number(panel.dataset.tabPanel || "0") === index;
        panel.classList.toggle("is-active", isActive);
      });

      // Update content panels
      this.contentPanels.forEach((panel) => {
        const isActive = Number(panel.dataset.tabPanel || "0") === index;
        panel.classList.toggle("is-active", isActive);
      });

      // Update slider groups synchronously for immediate visual feedback
      this.sliderGroups.forEach((group) => {
        const isActive = Number(group.dataset.tabPanel || "0") === index;
        group.classList.toggle("is-active", isActive);

        if (!isActive) return;

        const slider = group.querySelector("[data-tabbed-showcase-slider]");
        if (!slider) return;

        const applySliderPosition = (flkty) => {
          if (!flkty) return;
          flkty.resize();
          if (this._activateGoToLast && Number(group.dataset.tabPanel || "0") === index) {
            const last = Math.max(0, flkty.slides.length - 1);
            flkty.select(last, false, true);
            this._activateGoToLast = false;
          } else {
            flkty.select(0, false, true);
          }
          this.updateNavVisibility();
        };

        if (this.flktyInstances.has(slider)) {
          const flkty = this.flktyInstances.get(slider);
          applySliderPosition(flkty);
        } else if (!this.pendingInits.has(slider)) {
          // Initialize immediately without delay
          this.initSliderForGroup(group);
        }
      });

      this.updateNavVisibility();
    }
  }

  customElements.define("tabbed-showcase", TabbedShowcase);
})();
